<template>
  <div>
    <div class="col-md-12">
      <div class="row _mb">
        <div class="title">Gerenciar Usuários</div>

        <div class="c-card v--fill v--bordered" style="padding: 20px;border-radius: 8px;margin-top: 15px;background: rgba(0,0,0,.025);" v-if="!temContratoPosPagoAtivo">
          <p>
            A funcionalidade de ter vários usuários em uma conta está disponível apenas para clientes com contratos ativos.
            Converse com um dos nossos executivos e confira as condições exclusivas!
          </p>
          <a class="c-button c-button--small c-button--primary c-button--bold"
             style="display: inline-block"
             :href="linkReuniao" target="_blank">
            AGENDAR REUNIÃO
          </a>
        </div>

        <div class="col-md-12 add-users">
          <div class="mt">
            <a href="#" class="cliqueAqui" @click.prevent="openModalRolesPermissoes()">Clique aqui</a> para entender as funções.
          </div>
          <div>
            <button
              v-if="temContratoPosPagoAtivo"
              class="btn btn-background -right"
              type="button"
              :disabled="submitted"
              @click="openModalAdicionarUsuarios"
            >
              <div class="bold-font"> + Adicionar </div>
            </button>
          </div>
        </div>
      </div>
      <table class="Table table">
        <thead>
        <tr>
          <th class="table-header">Nome</th>
          <th class="table-header">Função</th>
          <th class="table-header">Último acesso</th>
        </tr>
        </thead>
        <tbody>
        <tr>
          <td style="display: flex">
            <img class="imagem-usuario" :src="organizacao.imagem" alt="avatar">
            <div>
              <div class="bold-font"> {{ organizacao.nome }} <br>
                <div class="light-font"> {{organizacao.email}} </div>
              </div>
            </div>
          </td>
          <td class="bold-font">{{ 'Admininistrador' }}</td>
          <td class="light-font" v-if="organizacao.ultima_acao">{{ dateTimeFormat(organizacao.ultima_acao.date) }}</td>
        </tr>
        <tr v-for="usuario in this.usuarios">
          <td style="display: flex">
            <img class="imagem-usuario" :src="usuario.imagem" alt="avatar">
            <div>
              <div class="bold-font"> {{ usuario.nome }} <br>
                <div class="light-font"> {{usuario.email}} </div>
              </div>
            </div>
          </td>
          <td>
            <select
              v-model="rolesUsuarios.find((role) => role.id === usuario.id).role_id"
              class="w-4/5"
              @change="onChange($event, usuario)"
            >
              <option v-for="cargo in cargos" :value="cargo.id">{{ cargo.nome }}</option>
            </select>
          </td>
          <td class="light-font" v-if="usuario.ultima_acao">{{ dateTimeFormat(usuario.ultima_acao.date) }}</td>
          <td>
            <button
              class="btn-remove"
              type="button"
              :disabled="submitted"
              @click="openModalRemoverUsuario(usuario)"
            >
              Remover
            </button>
          </td>
        </tr>
        <tr v-for="convitePendente in convitesPendentes">
          <td style="display: flex;opacity: 0.55">
            <img class="imagem-usuario" src="assets/images_upload/usuarios/missing.png" alt="avatar">
            <div>
              <div class="bold-font">Convite pendente<br>
                <div class="light-font">{{ convitePendente.email }}</div>
              </div>
            </div>
          </td>
          <td style="opacity: 0.55">
            {{ convitePendente.role }}
          </td>
          <td>
            <button
              class="btn btn-background btn-send-invite"
              @click="reenviarConvite(convitePendente.id)"
              type="button"
              :disabled="submitted">
              Reenviar
            </button>
          </td>
          <td>
            <button
              class="btn btn-background btn-delete-invite"
              @click="excluirConvite(convitePendente.id)"
              type="button"
              :disabled="submitted">
              Excluir
            </button>
          </td>
        </tr>
        </tbody>
      </table>
    </div>

    <adicionar-usuario-organizacao-modal
      :visible="showModalAdicionarUsuarios"
      :organizacao="this.organizacao"
      @closeModal="closeModal"
      @convidadoAdicionado="adicionaConvidadoLista"
    >
    </adicionar-usuario-organizacao-modal>

    <remover-usuario-organizacao-modal
      :visible="showModalRemoverUsuarios"
      :usuario="this.usuarioSelecionado"
      @closeModal="closeModal">
    </remover-usuario-organizacao-modal>

    <organizacao-roles-permissoes-modal
      :visible="showModalRolesPermissoes"
      :roles="this.rolesOrganizacao"
      @closeModal="closeModal">
    </organizacao-roles-permissoes-modal>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "OrganizacaoApi",
  props: {
    organizacao: {
      type: Object,
      required: true
    },
    usuarios: {
      type: Array,
      required: true
    },
    convitesPendentes: {
      type: Array,
      required: true
    },
    linkReuniao: {
      type: String,
      required: true
    },
    temContratoPosPagoAtivo: {
      type: Boolean,
      required: true
    },
    rolesOrganizacao: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      showModalAdicionarUsuarios: false,
      showModalRemoverUsuarios: false,
      showModalRolesPermissoes:false,
      usuarioSelecionado: this.usuarios[0],
      cargos: [
        {
          id: "2",
          nome: "Desenvolvedor"
        },
        {
          id: "3",
          nome: "Financeiro"
        }
      ],
      rolesUsuarios: [],
      submitted: false
    };
  },
  methods: {
    openModalAdicionarUsuarios: function() {
      this.showModalAdicionarUsuarios = true;
    },
    openModalRemoverUsuario: function(usuario) {
      this.showModalRemoverUsuarios = true;
      this.usuarioSelecionado = usuario;
    },
    openModalRolesPermissoes: function() {
      this.showModalRolesPermissoes = true;
    },
    dateTimeFormat: function(date) {
      if(date == null) {
        return 'Nunca acessou';
      }

      return moment(date).format('DD/MM/Y');
    },
    closeModal: function() {
      this.showModalAdicionarUsuarios = false;
      this.showModalRemoverUsuarios = false;
      this.showModalRolesPermissoes = false;
    },
    onChange: function(e, usuario){
      const role_id = e.target.value;
      let roleUsuario = this.rolesUsuarios.find((role) => role.id == usuario.id)
      EventBus.$emit('loading-show');

      this.submitted = true;
      axios({
        method: "put",
        url: "/organizacao/alterar-permissao/" + usuario.id,
        data: {
          role_id: role_id
        }
      })
        .then(response => {
          usuario.role_organizacao = role_id;
          this.submitted = false;
          EventBus.$emit('loading-hide');
          this.$store.dispatch("showLoadingMessage", {
            message: "Alteração feita com sucesso!",
            type: "done"
          });
        })
        .catch((error) => {
          this.submitted = false;
          roleUsuario.role_id = usuario.role_organizacao;
          EventBus.$emit('loading-hide');

          this.$store.dispatch('showHttpErrorMessage', {
            httpStatus: error.response.status,
            responseData: error.response.data
          });
        });
    },
    adicionaConvidadoLista: function(convidadoAdicionado) {
      let convidado = convidadoAdicionado;

      let role_id = convidado.cargo
      let cargo = '';

      for (let j = 0; j < this.cargos.length; j++) {
        if (this.cargos[j].id === role_id) {
          cargo = this.cargos[j].nome;
          break;
        }
      }

      this.convitesPendentes.push({
        email: convidado.email,
        role: cargo,
        id: convidado.id
      });
    },
    reenviarConvite(conviteId) {
      this.submitted = true;
      axios({
        method: "post",
        url: "/organizacao/convites/" +conviteId+ "/reenviar",
      })
        .then(response => {
          this.submitted = false;
          EventBus.$emit('loading-hide');
          this.$store.dispatch("showLoadingMessage", {
            message: "Convite reenviado com sucesso!",
            type: "done"
          });
        })
        .catch((error) => {
          this.submitted = false;
          EventBus.$emit('loading-hide');

          this.$store.dispatch('showHttpErrorMessage', {
            httpStatus: error.response.status,
            responseData: error.response.data
          });
        });
    },
    excluirConvite(conviteId) {
      this.submitted = true;
      axios({
        method: "delete",
        url: `/organizacao/convites/${conviteId}`,
      })
        .then(response => {
          this.submitted = false;
          EventBus.$emit('loading-hide');
          this.$store.dispatch("showLoadingMessage", {
            message: "Convite excluído com sucesso!",
            type: "done"
          });
          // remover o convite da lista
          this.convitesPendentes = this.convitesPendentes.filter(convite => convite.id !== conviteId);
        })
        .catch((error) => {
          this.submitted = false;
          EventBus.$emit('loading-hide');

          this.$store.dispatch('showHttpErrorMessage', {
            httpStatus: error.response.status,
            responseData: error.response.data
          });
        });
    }
  },
  created() {
    this.rolesUsuarios = this.usuarios.map(usuario => {
      return {
        'role_id': usuario.role_organizacao,
        'id': usuario.id
      };
    });
  },
};
</script>
<style lang="stylus" scoped>
.btn-background
  background-color #FFFFFF
  border 1px solid #D1D5DB
  color #000000
  box-shadow 0px 1px 2px rgba(0, 0, 0, 0.05)
  border-radius 6px
  text-transform none
.btn-background hover,
.btn-background active,
.btn-background focus
    background-color #B50E02
    border-color #B50E02
.imagem-usuario
  width 40px
  height 40px
  border-radius 50%
  margin-right 16px
.light-font
  color #6B7280
  font-style normal
  font-weight 400
  font-size 14px
  line-height 20px
.bold-font
  color #111827
  font-style normal
  font-weight 500
  font-size 14px
  line-height 20px
.title
  color #111827
  font-style normal
  font-weight 700
  font-size 30px
  line-height 44px
.bold-font-info
  color #111827
  font-style normal
  font-weight 500
  font-size 18px
  line-height 24px
.add-users
  display flex
  flex-direction row
  justify-content space-between
  align-items center
  padding 0px
  gap 16px
.btn-remove
  padding 0
  border none
  background none
  color #4F46E5
  font-style normal
  font-weight 400
  font-size 14px
  line-height 20px
.table-header
  font-style normal
  font-weight 500
  font-size 12px
  line-height 16px
  letter-spacing 0.05em
  text-transform uppercase
  color #6B7280
.mt
  margin-top 24px
.btn-delete-invite
  color #DC143C
  font-size 14px
  &:disabled
    color #D1D5DB
    cursor not-allowed
.btn-send-invite
  color #006400
  font-size 14px
  &:disabled
    color #D1D5DB
    cursor not-allowed
.cliqueAqui
  color #dc6c51
</style>
